import { getIsDesktop, getIsTablet, getBrowserClassName, } from '../../jsCore/utils/ua';
import { classList, } from '../../jsCore/utils/dom';
function getDeviceTypeClass(){
  if (getIsDesktop()) {
    return 'isDesktop';
  }
  return getIsTablet() ? 'isTablet' : 'isMobile';
}

classList(document.body).add(getDeviceTypeClass(), getBrowserClassName());



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/body/uaBodyClassModifier.js